<template>
    <vx-card title="Multi Process Test Page">
        <div class="flex md:flex-row">
            <div class="w-full pr-6 md:basis-1/2">
                <h4>Picking LCO</h4>
                <hr>
                <div class="mb-6 vx-row pt-2">
                    <div class="flex items-center w-full vx-col sm:w-1/3">
                        <span>Territory</span>
                    </div>
                    <div class="w-full vx-col sm:w-2/3">
                        <Territory @selected="(val) => { this.selectedTerritory = val }"></Territory>
                    </div>
                </div>
                <div class="mb-6 vx-row pt-2">
                    <div class="flex items-center w-full vx-col sm:w-1/3">
                        <span>Warehouse</span>
                    </div>
                    <div class="w-full vx-col sm:w-2/3">
                        <Warehouse @selected="(val) => { this.selectedWarehouse = val }" :territory-id="this.selectedTerritory"></Warehouse>
                    </div>
                </div>
                <div class="mb-6 vx-row pt-2">
                    <div class="flex items-center w-full vx-col sm:w-1/3">
                        <span>Search</span>
                    </div>
                    <div class="w-full vx-col sm:w-2/3">
                        <vs-input
                            type="text"
                            :value="this.searchLco"
                            class="w-full"
                            @input="(val) => { handleSearchLco(val); }"
                        />
                    </div>
                </div>
                <div class="mb-6 vx-row pt-2">
                    <div class="flex items-center w-full vx-col sm:w-1/3">
                        <span>Status LCO</span>
                    </div>
                    <div class="w-full vx-col sm:w-2/3">
                        <v-select
                            :filterable="true"
                            :options="statusLco"
                            v-model="selectedStatusLco"
                            label="name"
                            :clearable="false"
                        />
                    </div>
                </div>
                <div class="mb-6 vx-row pt-2">
                    <div class="flex items-center w-full vx-col sm:w-1/3">
                        <span>Limit</span>
                    </div>
                    <div class="w-full vx-col sm:w-2/3">
                        <vs-input
                            type="number"
                            :value="this.limitLco"
                            class="w-full"
                            :min="1"
                            @input="(val) => { handleChangeLimitLco(val); }"
                        />
                    </div>
                </div>
                <div class="mb-6 vx-row pt-2">
                    <div class="flex items-center w-full vx-col sm:w-1/3">
                        <span></span>
                    </div>
                    <div class="w-full vx-col sm:w-2/3">
                        <vs-button v-on:click="handleFilterLco()">Filter</vs-button>
                    </div>
                </div>
            </div>
            <div class="w-full md:basis-1/2">
                <div class="w-full pr-6 md:basis-1/2">
                    <h4>Info</h4>
                    <hr>
                    <div class="mb-6 vx-row pt-2">
                        <div class="flex items-center w-full vx-col sm:w-1/3">
                            <span>Document Count</span>
                        </div>
                        <div class="w-full vx-col sm:w-2/3">
                            <vs-input
                                type="text"
                                :value="this.documentChecked + ' / ' + this.documentCount"
                                class="w-full"
                                readonly
                            />
                        </div>
                    </div>
                    <div class="mb-6 vx-row pt-2">
                        <div class="flex items-center w-full vx-col sm:w-1/3">
                            <span>Process Complete?</span>
                        </div>
                        <div class="w-full vx-col sm:w-2/3">
                            <vs-button v-on:click="handleProcessLco" :disabled="disableProcess">Process</vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="vx-row mb-6">
            <div class="vx-col w-full">
                <vs-table stripe border style="width:100%" :data="dataLines">
                    <template slot="thead">
                        <vs-th><vs-checkbox @input="addAllCheckedLco" v-model="checkedAll" :disabled="disableProcess"></vs-checkbox>Select</vs-th>
                        <vs-th>Document</vs-th>
                        <vs-th>Date</vs-th>
                        <vs-th>Warehouse</vs-th>
                        <vs-th>Line Count(s)</vs-th>
                        <vs-th>Publish</vs-th>
                        <vs-th>Consume</vs-th>
                        <vs-th>Remark</vs-th>
                    </template>

                    <template slot-scope="">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in dataLines">
                            <vs-td>
                                <vs-checkbox
                                    @input="addCheckedLco(indextr, tr.id)"
                                    v-model="tr.check"
                                    :disabled="tr.doc_status === 'Complete'"
                                ></vs-checkbox>
                            </vs-td>
                            <vs-td>
                                <b>SO :</b> {{ tr.so_code }}
                                <br>
                                <b>DO :</b> {{ tr.do_code }}
                                <br>
                                <b>POD :</b> {{ tr.pod_code }}
                                <br>
                                <b>Status : {{ tr.doc_status }}</b>
                            </vs-td>
                            <vs-td>{{ formatDate(tr.pod_date) }}</vs-td>
                            <vs-td>{{ tr.warehouse_code }} - {{ tr.warehouse_name }}</vs-td>
                            <vs-td>{{ tr.line_count }}</vs-td>
                            <vs-td>{{ utcToLocal(tr.publish) }}</vs-td>
                            <vs-td>{{ utcToLocal(tr.consume) }}</vs-td>
                            <vs-td>{{ tr.remark }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>
    </vx-card>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import vSelect from "vue-select";
import Territory from "./component/Territory.vue";
import Warehouse from "./component/Warehouse.vue";
import PickingLcoTable from "./component/PickingLcoTable.vue";

export default {
    components: {
        vSelect,
        Territory,
        Warehouse,
        PickingLcoTable
    },
    data() {
        return {
            selectedTerritory: [],
            selectedWarehouse: [],
            checkedAll: false,
            checked: [],
            documentCount: 0,
            documentChecked: 0,
            searchLco: '',
            selectedStatusLco: null,
            disableProcess: false,
            limitLco: 10,
            statusLco: [
                {
                    name: "All",
                },
                {
                    name: "Pickup",
                },
                {
                    name: "Complete",
                },
            ],
            dataLines: [
                {
                    check: false,
                    id: 0,
                    so_code: '',
                    do_code: '',
                    pod_code: '',
                    pod_date: null,
                    line_count: 0,
                    warehouse_code: '',
                    warehouse_name: '',
                    publish: null,
                    consume: null,
                    remark: '',
                }
            ],
        }
    },
    mounted() {
        this.selectedStatusLco = this.statusLco[0]
    },
    methods: {
        handleFilterLco() {
            this.getDataLco();
        },
        getDataLco() {
            let territoryIds = [];
            this.selectedTerritory.forEach(val => {
                territoryIds.push(val.id)
            });

            let warehouseIds = [];
            this.selectedWarehouse.forEach(val => {
                warehouseIds.push(val.id)
            });

            let param = {
                search: this.searchLco,
                territory_id: territoryIds,
                warehouse_id: warehouseIds,
                status_lco: this.selectedStatusLco.name,
                limit: Number(this.limitLco),
            }

            this.$vs.loading();
            this.$http.post("/api/wms/v1/canvas/loading/data-table-lco", param)
            .then((resp) => {
                if (resp.code == 200) {
                    this.$vs.loading.close();
                    this.dataLines = resp.data.records;

                    this.checkedAll = false
                    this.checked = []
                    this.documentChecked = 0
                    this.documentCount = 0
                    this.disableProcess = false

                    var completeDocs = 0

                    this.dataLines.forEach(val => {
                        this.documentCount++
                        if (val.doc_status == "Complete") {
                            completeDocs++
                        }
                    });

                    if (this.documentCount == completeDocs) {
                        this.disableProcess = true
                    }
                } else {
                    this.$vs.loading.close();
                    this.$vs.dialog({
                        color: "danger",
                        title: "Something went wrong",
                        text: resp.message,
                    });
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                console.log(error);
                this.$vs.dialog({
                    color: "danger",
                    title: "Something went wrong",
                    text: error,
                });
            });
        },
        addAllCheckedLco() {
            if (this.checkedAll) {
                this.checked = []
                this.documentChecked = 0
                this.dataLines.forEach(val => {
                    if (val.doc_status !== 'Complete') {
                        val.check = this.checkedAll
                        this.checked.push(val.id)
                        this.documentChecked++
                    }
                })
            } else {
                this.checked = []
                this.dataLines.forEach(val => {
                    val.check = this.checkedAll
                    this.documentChecked = 0
                })
            }
        },
        addCheckedLco(index, val) {
            if (this.dataLines[index].check) {
                this.checked.push(val)
                this.documentChecked++
            } else {
                this.checked.splice(this.checked.indexOf(val), 1);
                this.documentChecked--
            }

            if (this.checked.length == this.dataLines.length) {
                this.checkedAll = true
            } else {
                this.checkedAll = false
            }
        },
        handleChangeLimitLco(val) {
            this.limitLco = val
        },
        handleSearchLco(val) {
            this.searchLco = val
        },
        handleProcessLco() {
            if (this.checked.length < 1) {
                this.$vs.notify({
                    color: "danger",
                    title: "Something went wrong",
                    text: "Please select document(s)",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-check"
                }); 
                return
            }

            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Pickup Confirm to Complete Confirmation`,
                text: "Please confirm to process this data",
                accept: () => {
                    this.checked.forEach(val => {
                        this.$http.patch(`/api/wms/v1/simple-outbound-planner/complete`, {
                            delivery_order_id: val,
                        })
                        .then(resp => {
                            if (resp.code == 200) {
                                this.$vs.dialog({
                                    color: "success",
                                    title: "Success",
                                    text: "The data was successfully proceessed",
                                });
                            } else {
                                this.$vs.dialog({
                                    color: "danger",
                                    title: "Something went wrong",
                                    text: resp.message,
                                });
                            }
                        })
                        .catch((error) => {
                            this.$vs.dialog({
                                color: "danger",
                                title: "Something went wrong",
                                text: error,
                            });
                        });
                    });
                }
            })
        },
        utcToLocal(val) {
            if (val) {
                return moment(val)
                    .utc()
                    .format("DD MMM YYYY HH:mm:ss");
            }
        },
    },
    computed: {
        formatDate: () => {
            return (val) => moment.utc(val).format("YYYY-MM-DD")
        },
    },
}
</script>